import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const OdooFAQ = () => {
  // const faqData = [
  //   {
  //     question: "Why should I consider hiring an Infor consultant from KCS Tech?",
  //     answer: "Expert Infor consultants from KCS Tech's minimize risks, enhance data quality, and ensure seamless integration, driving long-term success."
  //   },
  //   {
  //     question: "How can KCS Tech's Infor Consulting Services improve my business processes?",
  //     answer: "We provide end-to-end process optimization, customized solutions, and best practices implementation to streamline your operations and enhance efficiency."
  //   },
  //   {
  //     question: "What types of services do KCS Tech's Infor consultants typically provide?",
  //     answer: "KCS Tech's Infor consultants offer a comprehensive range of services, including migration, deployment, customization, upgrades, training, and management consulting for Infor LN, M3 and CloudSuite (Syteline), ensuring your software solutions are optimized for success."
  //   },
  //   {
  //     question: "What Industries can benefit from KCS Tech's Infor Consultation ?",
  //     answer: "KCS Tech's Infor consultation services benefit various industries, including manufacturing, distribution, fashion and apparel, healthcare, and chemicals, by optimizing operations and enhancing efficiency with tailored solutions like Infor LN, M3, and CloudSuite."
  //   },
  //   {
  //     question: "How do KCS Tech's Infor Managed Services ensure compliance and security for businesses?",
  //     answer: "KCS's Infor Managed Services implement robust security protocols and compliance measures, ensuring that your systems adhere to industry regulations while protecting sensitive data and minimizing risks."
  //   }
  // ];

  const faqData = [
    {
      question: "Is it easy to implement Odoo?",
      answer: "Yes, Odoo is designed to be user-friendly and can be implemented relatively easily with proper planning and guidance. The modular structure allows for gradual implementation, and with experienced consultants, the process becomes even more streamlined."
    },
    {
      question: "How long does it take to implement Odoo ERP?",
      answer: "The implementation timeline varies depending on your business size, complexity, and requirements. Typically, it can range from a few weeks for small businesses to several months for larger enterprises with complex needs."
    },
    {
      question: "Why choose Odoo partners over freelancers for Odoo implementation?",
      answer: "Odoo partners offer certified expertise, proven methodologies, ongoing support, and comprehensive training. They have direct access to Odoo resources and can provide better long-term maintenance and updates compared to individual freelancers."
    },
    {
      question: "Is it possible to integrate Odoo with other systems?",
      answer: "Yes, Odoo offers extensive integration capabilities through APIs and connectors. It can be integrated with various third-party applications, payment gateways, e-commerce platforms, and other business systems to create a unified workflow."
    },
    {
      question: "Is it possible to customize Odoo reports?",
      answer: "Absolutely! Odoo provides flexible reporting tools that allow you to create custom reports, modify existing ones, and generate reports in various formats. You can customize reports to match your specific business requirements and branding."
    },
    {
      question: "Do I need to customize my Odoo ERP?",
      answer: "Customization depends on your specific business needs. While Odoo offers many standard features out-of-the-box, you may need customization for unique workflows, industry-specific requirements, or to match your existing business processes."
    }
  ];
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <> 
      <h3 className="text-black text-center text-2xl mb-8 mt-10">FAQ's</h3>
      <div className="max-w-6xl mx-auto p-4 space-y-4">
        {faqData.map((faq, index) => (
          <div key={index} className="bg-gray-500  border-gray-200" style={{background:"#e9e7e9"}}>
            <button
              onClick={() => toggleFaq(index)}
              className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-100 transition-colors duration-200"
            > 
              <h3 className="text-lg font-medium text-purple-800" style={{color:"#2e025d"}}>{faq.question}</h3>
              <span className="text-purple-600 flex-shrink-0">
                {openIndex === index ? <FaChevronUp size={20} /> : <FaChevronDown size={20} />}
              </span>
            </button>
            
            <div
              className={`px-6 transition-all duration-200 ease-in-out ${
                openIndex === index 
                  ? 'max-h-96 py-4 opacity-100' 
                  : 'max-h-0 py-0 opacity-0'
              }`}
            >
              <p className="text-gray-600">{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default OdooFAQ;
